import 'dayjs/locale/id'

import { Descriptions, Empty, Spin } from '@pankod/refine-antd'
import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import React from 'react'

import type { TProgramLastConfig } from '../../../types'

dayjs.extend(utc)
dayjs.extend(timezone)

const formatImportedAt = (value: string) => {
  const importedAt = dayjs(value).tz('Asia/Jakarta')

  if (!importedAt.isValid()) return '-'

  return importedAt.locale('id').format('DD MMM YYYY HH:mm:ss [WIB]')
}

type HistoricalComponentProps = {
  data?: TProgramLastConfig | null
  loading?: boolean
}

export const HistoricalComponent = ({
  data,
  loading = false,
}: HistoricalComponentProps) => {
  return (
    <div className="mb-4">
      <h3 className="mb-4 text-base font-semibold">Riwayat Impor</h3>
      <Spin spinning={loading}>
        {data?.importedAt ? (
          <Descriptions
            bordered
            column={1}
            size="small"
            labelStyle={{ width: 150 }}
          >
            <Descriptions.Item label="Tanggal Impor">
              {formatImportedAt(data.importedAt)}
            </Descriptions.Item>
            <Descriptions.Item label="Program Sumber">
              [ID {data.sourceProgramId}] {data.sourceProgramName}
            </Descriptions.Item>
            <Descriptions.Item label="Konfigurasi">
              {data.configTypes.length ? (
                <ul className="pl-4 m-0">
                  {data.configTypes.map((configuration, index) => (
                    <li key={`${configuration}-${index}`}>{configuration}</li>
                  ))}
                </ul>
              ) : (
                '-'
              )}
            </Descriptions.Item>
            <Descriptions.Item label="Dieksekusi oleh">
              {data.email || data.userId || '-'}
            </Descriptions.Item>
          </Descriptions>
        ) : (
          <Empty
            description="Belum ada riwayat impor konfigurasi program"
            image={Empty.PRESENTED_IMAGE_SIMPLE}
          />
        )}
      </Spin>
    </div>
  )
}

export default HistoricalComponent
